module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_CYSTERNA_20.b5bb0463.svg";